import React from 'react';
import LoginPopupSiteEvent from "./LoginPopupSiteEvent";
import BuyOrSubscribePopupSiteEvent from "./BuyOrSubscribePopupSiteEvent";

export default function SiteEvents ()
{
    return(
        <React.Fragment>
            <LoginPopupSiteEvent />
            {/*<BuyOrSubscribePopupSiteEvent />*/}
        </React.Fragment>
    );
};



// WEBPACK FOOTER //
// ./src/containers/event-dispatcher/SiteEvents.jsx